import { createUseStyles } from 'react-jss';

export const addEditProductCategory = createUseStyles({
  container: {

  },
});
